//! ORIGINAL CODE FOR SWITCHBTN (RETRACT ACCESS)
// import React, { Component } from "react";
// import Switch from "react-switch";
// import { fire, auth } from "../../firebase/index";
// import { customLog } from "../../variables/Variables";

// class SwitchBtn extends Component {
//   constructor(props) {
//     super(props);

//     this.handleChange = this.handleChange.bind(this);

//     let prop = this.props.accessData;
//     let currRights = prop.allowAccess;

//     this.state = {
//       accessRights: currRights
//     };
//   }

//   handleChange() {
//     let prop = this.props.accessData;
//     let currState = this.state.accessRights;
//     customLog(currState);
//     const retractURL =
//       "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

//     const grantURL =
//       "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail";

//     const registry = fire
//       .database()
//       .ref("retractableSharingRegistry")
//       .child(auth.currentUser.uid)
//       .child(prop.id);

//     registry.update({
//       allowAccess: !currState
//     });

//     registry.once("value").then(async snapshot => {
//       if (snapshot.exists()) {
//         const snapshotVal = snapshot.val();
//         customLog(snapshotVal);
//         const emailOfSharedUser = snapshotVal.sharedToEmail;
//         const serialOfLock = snapshotVal.lockSerial;

//         const dataToSend = {
//           lockSerial: serialOfLock,
//           email: emailOfSharedUser,
//           ownerUid: auth.currentUser.uid
//         };

//         if (!currState === false) {
//           if (!snapshotVal.allowAccess) {
//             fetch(retractURL, {
//               method: "POST",
//               body: JSON.stringify(dataToSend)
//             });
//           }
//         } else if (!currState === true) {
//           if (snapshotVal.allowAccess) {
//             fetch(grantURL, {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json"
//               },
//               body: JSON.stringify(dataToSend)
//             });
//           }
//         }
//       }
//     });

//     this.setState({ accessRights: !currState });
//   }

//   render() {
//     return (
//       <Switch
//         onChange={this.handleChange}
//         checked={this.state.accessRights}
//         id="normal-switch"
//       />
//     );
//   }
// }

// export default SwitchBtn;

//! Switch Btn for Retract Access (with Group) - under development
import React, { Component } from "react";
import Switch from "react-switch";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class GroupSwitchBtn extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    let prop = this.props.accessData;
    let currRights = prop.allowAccess;

    this.state = {
      accessRights: currRights,
      superAdminID: "",
      currentLanguage: "",
      isOfflineAccessRetracted: "",
    };
  }

  componentWillMount() {
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });

    // // Fetch isOfflineAccessRetracted
    // fire
    //   .database()
    //   .ref("lockGroupManagement")
    //   .child(this.state.superAdminID) // super admin
    //   .child(auth.currentUser.uid) // sharer
    //   .child(this.props.accessData.id)
    //   .once("value")
    //   .then((snapshot) => {
    //     if (snapshot.exists()) {
    //       const data = snapshot.val();
    //       this.setState({
    //         isOfflineAccessRetracted: data.isOfflineAccessRetracted === true, // Default to false if missing
    //       });
    //     } else {
    //       this.setState({
    //         isOfflineAccessRetracted: false, // If no data exists, assume it's not retracted
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching isOfflineAccessRetracted:", error);
    //     this.setState({ isOfflineAccessRetracted: false }); // Default to false on error
    //   });
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  async handleChange() {
    let prop = this.props.accessData;
    console.log("group prop", prop);
    let currState = this.state.accessRights;
    customLog("currState " + currState);
    customLog(currState);
    const retractURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

    const grantURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail";


    const lockGroupManagement = fire
      .database()
      .ref("lockGroupManagement")
      .child(this.state.superAdminID) // super admin
      .child(auth.currentUser.uid) // sharer
      .child(prop.lockId) // group hash (make sure prop has it)
      .child("sharedInstances")
      .child(prop.id);

    lockGroupManagement.update({
        allowAccess: !currState,
      });
      console.log("lockGroupManagement", lockGroupManagement);

    lockGroupManagement.once("value").then(async (snapshot) => {
      if (snapshot.exists()) {
        const snapshotVal = snapshot.val();
        customLog(snapshotVal);
        const emailOfSharedUser = snapshotVal.sharedToEmail;
        const serialOfLock = snapshotVal.lockSerial;

        const dataToSend = {
          lockSerial: serialOfLock,
          email: emailOfSharedUser,
          ownerUid: auth.currentUser.uid,
          language: this.state.currentLanguage,
        };

        if (!currState === false) {
          if (!snapshotVal.allowAccess) {
            fetch(retractURL, {
              method: "POST",
              body: JSON.stringify(dataToSend),
            });
          }
        } else if (!currState === true) {
          if (snapshotVal.allowAccess) {
            fetch(grantURL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToSend),
            });
          }
        }
      }
    });

    this.setState({ accessRights: !currState });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    return (
      <Switch
        onChange={this.handleChange}
        checked={this.state.accessRights}
        id="normal-switch"
        disabled={this.state.isOfflineAccessRetracted} // Disable switch only if explicitly true
      />
    );
  }
}

export default GroupSwitchBtn;
